"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const date_fns_1 = require("date-fns");
function formatDate(date, options) {
    const now = new Date();
    const locale = ("translate" in options ? "en-US" : options.i18n.language).replace("_", "-");
    const t = "translate" in options ? options.translate : options.i18n.t;
    switch (options.strategy) {
        case "naturalDate":
            // NOTE: We dont' use Intl.RelativeTimeFormat for today and yesterday
            // because of its lack of control over capitalization
            if ((0, date_fns_1.isToday)(date)) {
                return t("Today");
            }
            else if ((0, date_fns_1.isYesterday)(date)) {
                return t("Yesterday");
            }
            else if ((0, date_fns_1.differenceInDays)(now, date) < 6) {
                return new Intl.DateTimeFormat(locale, { weekday: "long" }).format(date);
            }
            else if ((0, date_fns_1.isSameYear)(date, now)) {
                return new Intl.DateTimeFormat(locale, {
                    month: "long",
                    day: "numeric",
                }).format(date);
            }
            else {
                return new Intl.DateTimeFormat(locale, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                }).format(date);
            }
        case "numericDate":
            return new Intl.DateTimeFormat(locale, {
                month: "numeric",
                day: "numeric",
                year: "numeric",
            }).format(date);
        case "hidden":
            return "";
        default:
            return new Intl.DateTimeFormat(locale, {
                month: "short",
                day: "numeric",
                year: "numeric",
            }).format(date);
    }
}
exports.formatDate = formatDate;
